const PlaceholderQueryKeys = {
  global: ["placeholders"] as const,
  media: () => [...PlaceholderQueryKeys.global, "media"] as const,
  drafts: () => [...PlaceholderQueryKeys.global, "drafts"] as const,
  scheduled: () => [...PlaceholderQueryKeys.global, "scheduled"] as const,
};

export { PlaceholderQueryKeys };
